import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const SubCategoryPopup = ({ closePopup, editData }) => {
 // Form field states
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [category,setCategory] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vYWRtaW4vdjIvYXBpL2xvZ2luIiwiaWF0IjoxNzQ4MjQzMjM3LCJleHAiOjE3NjM3OTUyMzcsIm5iZiI6MTc0ODI0MzIzNywianRpIjoicEZiZlY0N3RtR3hIT1lLNCIsInN1YiI6IjQyMSIsInBydiI6IjlhZDU4NTc3ZmFiNmZiYzE1NTQzNGQzNTkxZWRmMTY0YTE3NzY1YWEiLCJhdXRoaWQiOjQyMSwib3JnaWQiOjEwMCwidXNlcmlkIjo0MjEsImRhdGFiYXNlbmFtZSI6InJhZ3VyciIsIm9yZ19jb2RlIjoicmFndXJyIiwidGltZXpvbmUiOiIgKyBpbnRlcnZhbCAnMDUgaG91cnMgMzAgbWludXRlcyciLCJyb2xlaWQiOjQwMSwicGF5bWVudF9zdGF0dXMiOnRydWUsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdfQ.W1Zci5YGI82pHEG8yyv1bBgC95okfRbQpn0iSYmzQig"; // 🔒 Use env variable for security

 
  useEffect(() => {
    if (editData?.id) {
      console.log("Fetching data for ID:", editData.id); // Debugging
  
      const fetchData = async () => {
        try {
          const response = await fetch(
            `https://api-uat.mawalog.com/cost_design/v1/api/costsolution/subcategory/get/${editData.id}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
  
          if (!response.ok) throw new Error("Failed to fetch data");
  
          const data = await response.json();
          console.log("Fetched Data:", data);
  
          // ✅ Check if subcategory exists and extract the first object from the array
          if (data.subcategory && data.subcategory.length > 0) {
            const subcategoryData = data.subcategory[0];
  
            setCode(subcategoryData.code || "");  // ✅ Fix: Correct field access
            setName(subcategoryData.name || "");
            setIsEditing(true);
          } else {
            console.log("Subcategory data is empty or undefined");
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          alert("Error fetching details");
        }
      };
  
      fetchData();
    }
  }, [editData?.id]); // ✅ Runs only when editData.id changes
  


  const handleSubmit = async (e) => {
    e.preventDefault();
    const postData = { code, name };

    try {
    

      const url = isEditing
        ? `https://api-uat.mawalog.com/cost_design/v1/api/costsolution/subcategory/${editData?.id}`
        : "https://api-uat.mawalog.com/cost_design/v1/api/costsolution/subcategory";

      console.log("Request Method:", isEditing ? "PUT" : "POST"); // ✅ Check method
      console.log("Request URL:", url); // ✅ Check URL

      const response = await fetch(url, {
        method: isEditing ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      });


      const data = await response.json();
      console.log("Response:", data);

      if (response.ok) {
        alert(isEditing ? "Data updated successfully!" : "Data saved successfully!");
        setCode("");
        setName("");
        setCategory("");
        closePopup();
      } else {
        alert("Error: " + (data.message || "Failed to process request"));
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong!");
    }
  };

  const handleClear = () => {
    setCode("");
    setName("");
    setCategory("");
  };


  return (
    <>
    <div className="scope-creation-popup-overlay">
    <div className="scope-creation-popup-container">
        {/* Close Button */}
        <div className="scope-creation-popup-header">
          <h2>{isEditing ? 'Edit Sub Category' : 'Create New Sub Category'}</h2>
          <button className="close-button" onClick={closePopup}>×</button>
        </div>

        <div className="scope-creation-popup-body">
        <div className="scope-creation-form-group" onSubmit={handleSubmit}>
          <label htmlFor="code" className="labels">Code</label>
          <input
            type="text"
            id="code"
            name="code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            style={{margin:'0px'}}
          />
          </div>

        <div className="scope-creation-form-group">
          <label htmlFor="category" className='name'>Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            style={{margin:'0px'}}
          />
          </div>

        <div className="scope-creation-form-group">
          <label htmlFor="category" className='name'>Category</label>
          <input
            type="text"
            id="category"
            name="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
            style={{margin:'0px'}}
          /></div>
               </div>
          {/* Clear, Submit/Update Buttons */}
          <div className="scope-creation-popup-footer">
             <button type="button" className='clear-button' onClick={handleClear}>Clear</button>
             <button className="submit-button" onClick={handleSubmit}>
            {isEditing ? 'Update' : 'Submit'}
          </button>
           </div>
      </div>
    </div>
     <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  );
}

export default SubCategoryPopup
